import hasOwn from './hasOwn';
/**
 * Returns value at path of given object or provided default value.
 * will return `undefined` if no default is given and path does not resolve
 *
 * @example
 * import pathOr from '@carvana/futilities/pathOr';
 * pathOr({ data: { price: { baselineMin: 5000 } } }, 'data.price.baselineMin', 0)
 * // () => 5000
 */
const pathTo = (obj: {}, path: string, defaultTo: any) => {
  let result = obj;
  const pathArr = path.split('.');
  while (pathArr.length) {
    const nextStep = pathArr.shift() as string;
    if (result && hasOwn(result, nextStep)) {
      result = result[nextStep];
    } else {
      return defaultTo;
    }
  }
  return result;
};

export default pathTo;
